const STAY_FLY = 'STAY:FLY';
const STAY_FLY_DRIVE = 'STAY:FLY:DRIVE';
const FLY_DRIVE = 'FLY:DRIVE';
const STAY_DRIVE = 'STAY:DRIVE';
const FLIGHT = 'FLY';
const CAR = 'DRIVE';
const TripTypeInfos = {
    [STAY_FLY]: {
        id: 'tripTypeAH',
        tripType: 'STAY:FLY',
        typeLabel: 'Hotel + Flight'
    },
    [STAY_FLY_DRIVE]: {
        id: 'tripTypeAHC',
        tripType: 'STAY:FLY:DRIVE',
        typeLabel: 'Hotel + Flight + Car'
    },
    [FLY_DRIVE]: {
        id: 'tripTypeAC',
        tripType: 'FLY:DRIVE',
        typeLabel: 'Flight + Car'
    },
    [STAY_DRIVE]: {
        id: 'tripTypeHC',
        tripType: 'STAY:DRIVE',
        typeLabel: 'Hotel + Car'
    }
};
const isHotelPlusCar = (tripType)=>tripType === STAY_DRIVE;
const isHotelFlightCar = (tripType)=>tripType === STAY_FLY_DRIVE;
const isHotelFlight = (tripType)=>tripType === STAY_FLY;
const hasHotel = (tripType)=>tripType.includes('STAY');
const hasFlight = (tripType)=>tripType.includes(FLIGHT);
const CHECKBOX_TEXT = {
    [STAY_FLY]: 'I only need a hotel for part of my stay',
    [STAY_FLY_DRIVE]: 'I only need a hotel for part of my stay',
    [STAY_DRIVE]: 'I want to pick up my car somewhere else',
    [FLY_DRIVE]: ''
};
const RADIO_OPTIONS = [
    {
        labelNode: 'Hotel + Flight',
        value: STAY_FLY,
        name: 'packagesType',
        size: '16'
    },
    {
        labelNode: 'Hotel + Flight + Car',
        value: STAY_FLY_DRIVE,
        name: 'packagesType',
        size: '16'
    },
    {
        labelNode: 'Flight + Car',
        value: FLY_DRIVE,
        name: 'packagesType',
        size: '16'
    },
    {
        labelNode: 'Hotel + Car',
        value: STAY_DRIVE,
        name: 'packagesType',
        size: '16'
    }
];
const PACKAGES_DEFAULT_VALUES = {
    tripType: STAY_FLY,
    partialStay: false,
    startDate: '',
    endDate: '',
    hotelStartDate: '',
    hotelEndDate: '',
    includeBasicEconomy: true,
    pickupCarSomewhere: false,
    rcPickupTime: '10:00',
    rcDropoffTime: '10:00'
};
const getTextString = (tripType)=>(text)=>{
        switch(tripType){
            case STAY_FLY_DRIVE:
                return `${text}hotel, flight and car`;
            case FLY_DRIVE:
                return `${text}flight and car`;
            case STAY_DRIVE:
                return `${text}hotel and car`;
            case STAY_FLY:
            default:
                return `${text}hotel and flight`;
        }
    };
export { CAR, CHECKBOX_TEXT, FLIGHT, FLY_DRIVE, PACKAGES_DEFAULT_VALUES, RADIO_OPTIONS, STAY_DRIVE, STAY_FLY, STAY_FLY_DRIVE, TripTypeInfos, getTextString, hasFlight, hasHotel, isHotelFlight, isHotelFlightCar, isHotelPlusCar };
